import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './productionOrderRows.html'

/**
 * ProductionOrderRows Report route
 *
 * @namespace routes.ReportProductionOrderRows
 * @type {TmrRoute}
 */
export const route = {
  name: 'report.productionOrderRows.list',
  label: 'REPORT.PRODUCTIONORDERS.TITLEROW',
  url: '/productionOrderRows',
  component: 'tmrReportProductionOrderRows',
  mainMenu: false,
  resourceType: 'ProductionOrderRow',
  resourceList: {
    searchParameters: [
      'creationDate.from',
      'creationDate.to',
      'rowCode',
      'order.code',
      'product.code',
      'item.identifier.code',
    ],
  },
  accessControl: ['Resource.list', 'Resource.ProductionOrderRow.list'],
}

/**
 * Component for {@link routes.tmrReportProductionOrderRows ProductionOrderRows Report route}
 *
 * @type {ngComponent}
 */
export const tmrReportProductionOrderRows = {
  ngType: 'component',
  templateUrl,
  bindings: resourceListBindings(),
}
